import request from '@/utils/request';

export function getList(data) {
  return request({
    url: '/inventoryclasss/load',
    method: 'post',
    data
  });
}

export function loadForRole(roleId) {
  return request({
    url: '/inventoryclasss/loadForRole',
    method: 'get',
    params: { appId: '', firstId: roleId }
  });
}

export function add(data) {
  return request({
    url: '/inventoryclasss/add',
    method: 'post',
    data
  });
}

export function update(data) {
  return request({
    url: '/inventoryclasss/update',
    method: 'post',
    data
  });
}

export function del(data) {
  return request({
    url: '/inventoryclasss/delete',
    method: 'post',
    data
  });
}

export function get(id) {
  return request({
    url: '/inventoryclasss/Get',
    method: 'get',
    params: { id: id }
  });
}

export function getChildrenData(parentCode) {
  return request({
    url: '/inventoryclasss/getChildrenData',
    method: 'get',
    params: { parentCode: parentCode }
  });
}

export function getAllData() {
  return request({
    url: '/inventoryclasss/getAllData',
    method: 'get'
  });
}

export function getloadfile(data) {
  return request({
    url: '/inventoryclasss/GetLoadFile',
    method: 'post',
    responseType: 'arraybuffer',
    data
  });
}
